import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import VueApexCharts from "vue3-apexcharts";
import VueFlatpickr from "vue-flatpickr-component";
import ColorisPlugin from "./plugins/coloris.plugin.js";
import AppMultiselect from "./components/AppMultiSelect.vue";
import { useConfigStore } from "./stores/config.js";
import i18n from "./i18n/index.js";

import "./styles.css";
import "./components/style/ConfigColors.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "flatpickr/dist/flatpickr.css";

import { can } from "@/utils/permission";
import NumberFormatPlugin from "./plugins/numberFormat.plugin.js";



// Import API + init axios stores
import api, { initAxiosStores } from "@/api/axios";

const app = createApp(App);
app.config.globalProperties.$can = can;
app.use(NumberFormatPlugin);

// Suppress experimental warnings (opsional)
app.config.warnHandler = (msg) => {
  if (msg.includes("Suspense") && msg.includes("experimental")) return;
  console.warn(msg);
};

const pinia = createPinia();
app.use(pinia);
app.use(i18n);

initAxiosStores();

// Config load
const configStore = useConfigStore();
configStore.loadConfig().then(() => {
  const titleEl = document.getElementById("page-title");
  const faviconEl = document.getElementById("favicon");
  if (titleEl) titleEl.textContent = configStore.websiteTitle();
  if (faviconEl) faviconEl.href = configStore.websiteIcon();
});

app.use(VueApexCharts);
app.component("VueFlatpickr", VueFlatpickr);
app.component("AppMultiselect", AppMultiselect);

app.use(ColorisPlugin, {
  themeMode: "auto",
  alpha: true,
  formatToggle: true,
  swatches: [
    "#1F1F1F",
    "#03193b",
    "#F59E0B",
    "#EF4444",
    "#8B5CF6",
    "#111827",
    "#ffffff",
  ],
});

app.mount("#app");
